<script>
  // Pending-state label convention: present participle + ellipsis, matching the
  // action ("Saving…", "Creating…"), not a generic "Loading…" — set by the caller
  // via the button's text, since the label is action-specific.
  let {
    variant = 'primary', // primary | secondary | danger | ghost
    type = 'button',
    disabled = false,
    href = null,
    onclick = null,
    children,
  } = $props();

  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    danger: 'btn bg-red-800 text-secondary-50 hover:bg-red-900',
    ghost: 'btn btn-ghost bg-transparent text-secondary-700 hover:bg-primary-900/5',
  };

  let cls = $derived(`${variants[variant] || variants.primary} ${disabled ? 'opacity-50 pointer-events-none' : ''}`);
</script>

{#if href}
  <a {href} class={cls} {onclick}>{@render children?.()}</a>
{:else}
  <button {type} {disabled} class={cls} {onclick}>{@render children?.()}</button>
{/if}
